import { render, staticRenderFns } from "./VuesticProgressBar.vue?vue&type=template&id=674d7436&"
import script from "./VuesticProgressBar.vue?vue&type=script&lang=js&"
export * from "./VuesticProgressBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "VuesticProgressBar.vue"
export default component.exports